import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class ExperimentalWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "lab", title: "Experimental Home", href: "/experimental" },
            { icon: "book", title: "Knowledge Base", href: "/experimental/kb" },
            { icon: "comment alternate", title: "KB Query", href: "/experimental/kb/query" },
            { icon: "file alternate", title: "KB Documents", href: "/experimental/kb/documents" },
            { icon: "cloud upload", title: "KB Upload", href: "/experimental/kb/upload" },
            { icon: "cogs", title: "Factory QA Tools", href: "/experimental/qa-tools" },
            { icon: "dollar sign", title: "DHL Charges", href: "/experimental/dhl-charges" },
            { icon: "server", title: "Workers", href: "/experimental/workers" },
            { icon: "shipping fast", title: "Shippo Analytics", href: "/experimental/shippo-analytics" },
            { icon: "globe", title: "Team Globe", href: "/experimental/team-globe" },
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
